import {
  Panel,
  SkeletonAvatar,
  SkeletonButton,
  SkeletonText,
} from '@dev-spendesk/grapes';

import styles from '@finance-review/components/form.module.css';

const skeletonButtonCount = 5;

export const ExpenseReviewFormSkeleton = () => {
  return (
    <Panel
      className={styles.form}
      header={
        <div className="flex h-64 items-center gap-8 pt-16">
          <SkeletonAvatar variant="circle" />
          <SkeletonText width="96px" size="l" />
        </div>
      }
      footer={
        <div className="flex justify-between gap-16">
          <SkeletonButton className="flex-1" />
          <SkeletonButton className="flex-1" />
        </div>
      }
    >
      <div>
        {Array.from({ length: skeletonButtonCount }, (_, key) => (
          <div className="mb-16" key={key}>
            <SkeletonText width="96px" size="l" />
            <SkeletonButton width="100%" />
          </div>
        ))}
      </div>
    </Panel>
  );
};
